import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import ServiceAccount from './ServiceAccount'
import BillData from './BillData'
import DetailTables from './DetailTables'
import { Flex } from 'hljd'
import Store from './store'
import { Provider } from 'mobx-react'

export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  componentDidMount() {
    this.store.getBrokerageInfo()
  }

  render() {
    return (
      <Provider pageStore={this.store}>
        <HeaderView contentStyle={{ backgroundColor: 'initial', padding: 0 }}>
          <Flex>
            <ServiceAccount />
            <BillData />
          </Flex>

          <DetailTables />
        </HeaderView>
      </Provider>
    )
  }
}
